import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { AppDataDemo } from '../../../data';
import { useTemplate } from '../../features/template/TemplateProvider';
import { handleGetSubscriptionsOpe } from './SubscriptionsOperation';

const SubscriptionsContext = createContext();

export const useSubscriptions = () => useContext(SubscriptionsContext);

function SubscriptionsProvider({ children }) {
    const [params, setParams] = useState({});
    // --Data reload
    const [reloadKey, setReloadKey] = useState(0);
    // --Store initial data
    const [subscriptionsData, setSubscriptionsData] = useState(AppDataDemo);
    // --Subscriptions view features show/hide control
    const [openAppFeaturesModal, setOpenAppFeaturesModal] = useState(false);
    // --Subscriptions add features show/hide control
    const [showAddAppFeaturesModal, setShowAddAppFeaturesModal] = useState(false);
    const { setMessage } = useTemplate();

    // -- Load all customer initially
    useEffect(() => {
        setSubscriptionsData({ subscriptions: AppDataDemo, pagination: {} });
        if (Object.keys(params).length > 0) {
            handleGetSubscriptionsOpe(params)
                .then(({ data }) => {
                    setSubscriptionsData(data);
                })
                .catch((err) => {
                    setSubscriptionsData({ subscriptions: [], pagination: {} });
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        }
    }, [setMessage, reloadKey, params]);

    const value = useMemo(() => {
        // -- Reload Button
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };
        // -- App Features show Modal
        const handleAppFeatures = () => {
            setOpenAppFeaturesModal(true);
        };

        const handleAddedNewFeature = () => {
            setShowAddAppFeaturesModal((d) => !d);
        };

        return {
            // Filter Data
            params,
            setParams,
            // Subscriptions Data
            subscriptionsData,
            setSubscriptionsData,
            // -- Reload
            reloadKey,
            setReloadKey,
            handleReload,

            // Modal
            openAppFeaturesModal,
            setOpenAppFeaturesModal,
            handleAppFeatures,
            // --Subscriptions add features show/hide control
            showAddAppFeaturesModal,
            setShowAddAppFeaturesModal,
            handleAddedNewFeature
        };
    }, [openAppFeaturesModal, params, reloadKey, showAddAppFeaturesModal, subscriptionsData]);

    return <SubscriptionsContext.Provider value={value}>{children}</SubscriptionsContext.Provider>;
}

export default SubscriptionsProvider;
